import { simpleGet, simplePost } from "./apiConfig"

export const getSafetyTickets = () => simpleGet('/safety_tickets.json')

export const getUserTickets = () => simpleGet('/user-tickets.json')

export const getRequirements = () => simpleGet('/requirements.json')

export const createUserTicket = (payload) => simplePost('/user-tickets', payload)
